import { ShoppingCartIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";

const ButtonCart = () => {
  const navigate = useNavigate();

  return (
    <div className="relative">
      <button
        onClick={() => navigate("/gio-hang")}
        className={`fixed bottom-4 right-4 mb-14 z-50 p-3 bg-primary text-white rounded-full shadow-lg hover:bg-opacity-80 active:scale-90 transition duration-200 `}
      >
        <ShoppingCartIcon className="w-6 h-6 text-yellow-500" />{" "}
        {JSON.parse(localStorage?.getItem("cart"))?.length > 0 && (
          <div className=" bg-red-500 text-white-600 absolute  z-20  top-0 ml-6 mb-3 rounded-full w-6 h-6 flex justify-center items-center">
            {JSON.parse(localStorage?.getItem("cart"))?.length}
          </div>
        )}
      </button>
    </div>
  );
};

export default ButtonCart;
